var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background w100",style:([
    { 'background-color': _vm.$route.name === 'search' ? '#EBF0F1' : 'white' },
  ])},[_c('Navbar'),_c('div',{attrs:{"id":"router-view"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('div',{staticClass:"contactWidgetContainer"},[_c('ContactFull',{staticClass:"contactWidget"})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }